import { useUserQuery } from 'api/user/queries'

export const useHasAdminAccess = () => {
  const { data: adminRights } = useUserQuery({
    select: data => data.user.adminRights,
  })

  if (!adminRights) {
    return false
  }

  const hasAdminAccess = Object.values(adminRights).some(
    value => value === true,
  )

  return hasAdminAccess
}
